import { Badge } from "../ui/badge";
import { CONDITION_COLORS, STATUS_COLORS, CRITICALITY_COLORS, TONE_CLASSES, serviceLabel, warrantyLabel, titleCase } from "./assetUtils";

export const ConditionBadge = ({ value, testid }) => (
  <Badge variant="outline" className={`text-[10px] capitalize ${CONDITION_COLORS[value] || ""}`} data-testid={testid}>{value || "—"}</Badge>
);
export const StatusBadge = ({ value, testid }) => (
  <Badge className={`text-[10px] ${STATUS_COLORS[value] || ""}`} data-testid={testid}>{titleCase(value || "active")}</Badge>
);
export const CriticalityBadge = ({ value, testid }) => (
  <Badge variant="outline" className={`text-[10px] capitalize ${CRITICALITY_COLORS[value] || ""}`} data-testid={testid}>{value || "medium"} criticality</Badge>
);
export const ServiceBadge = ({ asset, testid }) => {
  const s = serviceLabel(asset);
  return <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium ${TONE_CLASSES[s.tone]}`} data-testid={testid}>{s.text}</span>;
};
export const WarrantyBadge = ({ asset, testid }) => {
  const w = warrantyLabel(asset);
  return <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium ${TONE_CLASSES[w.tone]}`} data-testid={testid}>{w.text}</span>;
};
